import { GotoAction } from '@platform-frontend/util';

export class GotoScaSpinner extends GotoAction {
  static readonly type = '[Sca] Goto sca spinner';
}
